export const SUMMARY_FORMATS = {
  "5min": {
    label: "Quick Sip",
    description: "The most important points—clear, crisp, and to the point.",
    durationLabel: "≈ 5 min",
  },
  "10min": {
    label: "Deep Draught",
    description: "A richer look at the book's ideas with added clarity and depth.",
    durationLabel: "≈ 15 min",
  },
  "15min": {
    label: "Segmented Sips",
    description: "Sequential sips that break down the book's narrative, chapter by chapter, at your own pace.",
  },
} as const;

export type SummaryFormatKey = keyof typeof SUMMARY_FORMATS;

export const getSummaryFormatLabel = (format?: string) => {
  if (!format) return "Summary";
  return SUMMARY_FORMATS[format as SummaryFormatKey]?.label ?? "Summary";
};

export const getSummaryFormatDescription = (format?: string) => {
  if (!format) return "";
  return SUMMARY_FORMATS[format as SummaryFormatKey]?.description ?? "";
};

